export const initialState = {
  UserList: [],
  UserPage: {}
};
